'use strict';
import { j as s } from "../../external/react/jsx-runtime.js";
import r from "./form.module.scss.js";
import { FontAwesomeIcon as t } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faCheck as a } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
const j = ({
  name: e,
  label: o,
  checked: l,
  error: n,
  required: i,
  ...c
}) => /* @__PURE__ */ s.jsx("div", { className: r["field-container"], children: /* @__PURE__ */ s.jsxs("div", { className: r["checkbox-container"], children: [
  l ? /* @__PURE__ */ s.jsx(t, { icon: a }) : null,
  /* @__PURE__ */ s.jsx(
    "input",
    {
      type: "checkbox",
      id: e,
      name: e,
      checked: l,
      required: i,
      "data-has-error": n,
      ...c
    }
  ),
  o ? /* @__PURE__ */ s.jsxs("div", { className: r["label-container"], children: [
    /* @__PURE__ */ s.jsx("label", { htmlFor: e, children: o }),
    i ? /* @__PURE__ */ s.jsx("span", { className: r.required, children: "*" }) : null
  ] }) : null
] }) });
export {
  j as default
};
